import { http } from './http.ts';
import type { ApiSuccess, StreamDescriptor } from './types.ts';

export type CameraRelayUrls = {
  hls360: string | null;
  hlsPtz: string | null;
};

function pickRelayUrl(raw: Record<string, unknown>, ...keys: string[]): string | null {
  for (const key of keys) {
    const v = raw[key];
    if (typeof v === 'string' && v.trim() !== '') return v.trim();
  }
  return null;
}

export const streamsApi = {
  async getDescriptor(cameraId: string, signal?: AbortSignal): Promise<StreamDescriptor> {
    const res = await http.get<ApiSuccess<StreamDescriptor>>(
      `/api/cameras/${cameraId}/stream`,
      { signal },
    );
    return res.data.data;
  },

  /** Start 360° + PTZ relays (same as wankhede-360 live preview). */
  async startRelay(cameraId: string, signal?: AbortSignal): Promise<CameraRelayUrls> {
    const res = await http.post<ApiSuccess<Record<string, unknown>>>(
      `/api/cameras/${cameraId}/relay/start`,
      undefined,
      { signal },
    );
    const row = res.data.data ?? {};
    return {
      hls360: pickRelayUrl(row, 'hls360', 'hls_360'),
      hlsPtz: pickRelayUrl(row, 'hlsPtz', 'hls_ptz'),
    };
  },
};
